
import Button from '../../../components/base/Button';

export default function CTASection() {
  return (
    <section 
      className="relative py-32 overflow-hidden"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/0a8da3ba931d7ad1cc94e2d9daea87b8.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 via-purple-900/80 to-black/90"></div>
      
      {/* Animated Particles */}
      <div className="absolute inset-0">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white/30 rounded-full animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${Math.random() * 6 + 2}px`,
              height: `${Math.random() * 6 + 2}px`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${Math.random() * 3 + 4}s`
            }}
          />
        ))}
      </div>

      <div className="relative z-10 container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-6 py-3 mb-8">
              <i className="ri-flag-line text-orange-400"></i>
              <span className="text-white font-medium">Join India's Space Revolution</span>
            </div>
            
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Transform{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">
                India's Future
              </span>{' '}
              in Space
            </h2>
            
            <p className="text-xl md:text-2xl text-gray-200 mb-12 leading-relaxed">
              Partner with Vyoamyug Aerospace to build scalable, intelligent aerospace technologies. 
              From heavy-lift launch vehicles to AI-powered satellites, together we'll position 
              India as a global leader in space and defence innovation.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-16">
            <a href="mailto:partnerships@vyoamyug.com?subject=Partnership Inquiry">
              <Button variant="primary" size="lg" className="group bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 whitespace-nowrap cursor-pointer">
                <i className="ri-handshake-line mr-2 group-hover:scale-110 transition-transform"></i>
                <span>Partner With Us</span>
              </Button>
            </a>
            <a href="mailto:rahul@vyoamyug.com?subject=Investment Opportunity Inquiry">
              <Button variant="outline" size="lg" className="group border-white text-white hover:bg-white hover:text-gray-900 whitespace-nowrap cursor-pointer">
                <i className="ri-funds-line mr-2 group-hover:scale-110 transition-transform"></i>
                <span>Investment Opportunities</span>
              </Button>
            </a>
            <a href="mailto:rahul@vyoamyug.com?subject=Connect with Founder">
              <Button variant="secondary" size="lg" className="group bg-white/10 backdrop-blur-sm border border-white/20 text-white hover:bg-white hover:text-gray-900 whitespace-nowrap cursor-pointer">
                <i className="ri-phone-line mr-2 group-hover:translate-y-1 transition-transform"></i>
                <span>Connect with Founder</span>
              </Button>
            </a>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full mx-auto mb-4">
                <i className="ri-rocket-line text-2xl text-blue-400"></i>
              </div>
              <div className="text-3xl font-bold text-white mb-2">40,000kg</div>
              <div className="text-gray-300 text-sm">Yuga-1 LEO Capacity</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full mx-auto mb-4">
                <i className="ri-map-pin-line text-2xl text-green-400"></i>
              </div>
              <div className="text-3xl font-bold text-white mb-2">Pune</div>
              <div className="text-gray-300 text-sm">Maharashtra HQ</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-yellow-400"></i>
              </div>
              <div className="text-3xl font-bold text-white mb-2">IN-SPACe</div>
              <div className="text-gray-300 text-sm">Authorized & Registered</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full mx-auto mb-4">
                <i className="ri-global-line text-2xl text-purple-400"></i>
              </div>
              <div className="text-3xl font-bold text-white mb-2">7+</div>
              <div className="text-gray-300 text-sm">Core Applications</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}